/**
 * Regional Coverage — shared data source.
 *
 * Consumed by:
 *  · pages/RegionalCoveragePage.jsx (dedicated /regional-coverage page · full bios)
 *  · pages/TeamPage.jsx (compact card grid on /team)
 *  · components/landing/Partnership.jsx (homepage block · Regional Coverage tier)
 *
 * "Regional Coverage" is the tier of regionally-based representatives who
 * are the partnership's on-the-ground contact point in a market — engaged
 * on documented, non-executive terms, without partner economics. They
 * facilitate introductions; investment engagement is concluded by the
 * partnership.
 */
export const REGIONAL_COVERAGE = [
  {
    id: "sven-massenhove",
    anchor: "sven-massenhove",
    initials: "SM",
    name: "Sven Massenhove",
    role: "Gulf Region Lead · Dubai (DIFC)",
    subtitle: "Senior Advisor · Life Sciences & Pharma · UAE & GCC Investor Coverage",
    focus: "Senior Advisor · Life Sciences & Pharma · UAE & GCC Investor Coverage",
    short:
      "Sven is the partnership's on-the-ground contact point in the Gulf — leading investor relationships across the UAE and wider GCC from Dubai (DIFC) — and additionally advises the partnership on life-sciences and pharma opportunities as Senior Advisor.",
    bio: [
      "Sven Massenhove serves as Gulf Region Lead at Kellermann Reid & Co., based in Dubai within the Dubai International Financial Centre. He is the partnership's on-the-ground contact point for institutional, sovereign-adjacent and family-office relationships across the United Arab Emirates and the wider GCC, facilitating introductions that lead back to the partnership's Capital Formation function. He additionally serves as Senior Advisor for Life Sciences & Pharma, contributing sector pattern recognition to the evaluation of bioscience, pharmaceutical and healthcare-adjacent opportunities.",
      "Sven is the Founder and Chief Executive Officer of BioNexium, a Dubai-based deep-tech biotechnology firm advancing precision regenerative therapeutics that target chronic disease, metabolic dysfunction and cognitive decline. He founded and leads the company's two proprietary platforms — StemRevive-X, an autologous cell-based regenerative framework, and Quantum BioForge, a computational platform that models protein-protein interactions to identify high-affinity therapeutic peptide sequences.",
      "With more than six years of executive leadership in biotechnology, his technical focus spans synthetic peptide chemistry, bio-nanotechnology, mitochondrial optimisation and multi-omics data integration. He has led BioNexium's strategy from target discovery through pre-clinical validation and is establishing the company's ecosystem within the DIFC Innovation Hub — giving him a working, first-hand understanding of the Gulf's institutional and family-office capital landscape.",
      "Regional coverage is conducted on documented, non-executive terms. Sven does not hold partner economics and does not act as a placement agent or authorised representative; investment discussions, diligence and documentation are conducted by the partnership directly.",
    ],
    pillars: [
      { label: "Region", value: "UAE · GCC" },
      { label: "Base", value: "Dubai (DIFC)" },
      { label: "Sector Advisory", value: "Life Sciences & Pharma" },
    ],
    email: "sven.massenhove@krprivatecapital.com",
    phone: "+971 50 873 6233",
    linkedin: "https://www.linkedin.com/in/sven-massenhove/",
    photo: "/portraits/sven-massenhove.jpg",
  },
];
